import * as React from 'react';
import { ZoomInButton } from '../Controls/ZoomInButton';
import { ZoomOutButton } from '../Controls/ZoomOutButton';
import * as styles from './index.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ZoomControls = function ZoomControls(_ref) {
  var onZoomIn = _ref.onZoomIn,
    onZoomOut = _ref.onZoomOut,
    zoomInDisabled = _ref.zoomInDisabled;
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [/*#__PURE__*/_jsx(ZoomInButton, {
      onClick: function onClick() {
        return !zoomInDisabled && onZoomIn();
      },
      disabled: !!zoomInDisabled
    }), /*#__PURE__*/_jsx(ZoomOutButton, {
      onClick: onZoomOut
    })]
  });
};